// extracted by mini-css-extract-plugin
export var fadeIn = "_bb-0";
export var panelInner = "_bb-2";
export var panelOuter = "_bb-1";